/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import { Link } from 'react-router-dom';
// import { BsTwitter, BsYoutube } from 'react-icons/bs';
import { SiLinkedin } from 'react-icons/si';
// import { FaFacebookF } from 'react-icons/fa';
import '../pages/Zackat.css';

const redirectToLinkedIn = () => {
  window.open('https://www.linkedin.com/company/zackat-labs-inc/', '_blank');
};

const Footer = () => (
  <div className="footer-wrapper">
    <div className="footer-section-one">
      <div className="footer-icons">
        {/*
          <BsTwitter />
          */}

        <ButtonComponent onClick={redirectToLinkedIn}>
          <SiLinkedin />
        </ButtonComponent>

        {/*
          <BsYoutube />
          <FaFacebookF />
          */}
      </div>
    </div>
    {/*
    <iframe src="https://www.americanprogress.org/article/extreme-heat-is-more-dangerous-for-workers-every-year/" title="Acknoldgement" height="500" width="500" />
    */}
    <div className="footer-section-two">
      {/* }
        <div className="footer-section-columns">
          <span>Help</span>
          <span>Share</span>
        </div>
        */}
      <div className="footer-section-columns">
        <span className="membership">Contact Information</span>
        <span>
          Call: <Link to="tel:9726886359" style={{ textDecoration: 'underline !important' }}>(972) 688-6359</Link>
        </span>
        <span>
          Email:
          <a href="mailto:info@zackatlabs.com">
            info@zackatlabs.com
          </a>
        </span>
        {/*
          <span>press@zackatlabs.com</span>
          <span>contact@zackatlabs.com</span>
          */
          }
      </div>
      {/*
        <div className="footer-section-columns">
          <span>Terms & Conditions</span>
          <a href="/privacy">Privacy Policy</a>
          <a href="/hipaa">HIPAA Consent</a>
        </div>
        */}
    </div>
    <div className="footer-section-two">
      <div className="footer-section-columns">
        <span className="membership">Memberships</span>
        <a href="https://www.aiha.org">American Industrial Health Association - AIHA</a>
        <a href="https://www.acgih.org">American Conference of Governmental Industrial Hygienists - ACGIH</a>
        <a href="https://www.assp.org">American Society of Safety Professionals - ASSP</a>
      </div>
    </div>
  </div>
);
export default Footer;
